import * as tslib_1 from "tslib";
import { HttpResponse } from '@angular/common/http';
import { CryptoVaultService } from '../../../external/crypto-vault/crypto-vault.service';
import * as i0 from "@angular/core";
import * as i1 from "../../../external/crypto-vault/crypto-vault.service";
var CryptoVaultCipherCommunicatorService = /** @class */ (function () {
    function CryptoVaultCipherCommunicatorService(cryptoVaultService) {
        this.cryptoVaultService = cryptoVaultService;
    }
    CryptoVaultCipherCommunicatorService.prototype.encryptRequest = function (options) {
        var _this = this;
        var headers = options.headers;
        if (!headers) {
            return new Promise(function () { return options; });
        }
        var transactionId = headers.get('transaction_id');
        /*if(transactionId !== null){
          this.cryptoVaultService.keyExchange(transactionId);
        }*/
        return new Promise(function (resolve) {
            _this.cryptoVaultService.encrypt(JSON.stringify(options.body)).then(function (encryptedMessage) {
                options.body = {
                    message: encryptedMessage,
                };
                resolve(options);
                return;
            });
        });
    };
    CryptoVaultCipherCommunicatorService.prototype.decryptResponse = function (encryptedResponse, options) {
        var _this = this;
        var headers = options.headers;
        if (!headers) {
            return new Promise(function () { return encryptedResponse; });
        }
        var transactionId = headers.get('transaction_id');
        return new Promise(function (resolve) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                if (encryptedResponse.body.data.message) {
                    resolve(encryptedResponse);
                    return [2 /*return*/];
                }
                this.cryptoVaultService.decrypt(encryptedResponse.body.data.message).then(function (body) {
                    var decryptedResponse = new HttpResponse({
                        status: 200,
                        body: JSON.parse(body),
                    });
                    resolve(decryptedResponse);
                });
                return [2 /*return*/];
            });
        }); });
    };
    CryptoVaultCipherCommunicatorService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CryptoVaultCipherCommunicatorService_Factory() { return new CryptoVaultCipherCommunicatorService(i0.ɵɵinject(i1.CryptoVaultService)); }, token: CryptoVaultCipherCommunicatorService, providedIn: "root" });
    return CryptoVaultCipherCommunicatorService;
}());
export { CryptoVaultCipherCommunicatorService };
